import request from '@/plugin/axios'

/**
 * 根据条件查询结算记录
 * @param params
 * @returns {AxiosPromise}
 */
export function findRoomBillingStatementPage (params) { // PresetRecord
  return request({
    url: '/v1/electricity/roomBillingStatement/findRoomBillingStatementPage',
    method: 'get',
    params
  })
}

/**
 * 根据条件查询结算记录
 * @param params
 * @returns {AxiosPromise}
 */
export function findRoomBillingStatementGroupByRoomId (params) { // PresetRecord
  return request({
    url: '/v1/electricity/roomBillingStatement/findRoomBillingStatementGroupByRoomId',
    method: 'get',
    params
  })
}

/**
 * 根据条件查询结算记录
 * @param params
 * @returns {AxiosPromise}
 */
export function findRoomBillingDetailsPage (params) { // PresetRecord
  return request({
    url: '/v1/electricity/roomBillingStatement/findRoomBillingDetailsPage',
    method: 'get',
    params
  })
}

/**
 * 根据条件查询结算记录
 * @param params
 * @returns {AxiosPromise}
 */
export function findInsufficientBalanceVoPage (params) { // PresetRecord
  return request({
    url: '/v1/electricity/roomBillingStatement/findInsufficientBalanceVoPage',
    method: 'get',
    params
  })
}
